/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AuthTokensDto,
  ProblemDetails,
  RefreshSessionCommand,
  RequestOtpCommand,
  SignOutCommand,
  ValidationProblemDetails,
  VerifyOtpCommand
} from '.././model';

import { request } from '../../http-client';




export const postApiV1AuthOtpRequest = (
    requestOtpCommand: RequestOtpCommand,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/auth/otp/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestOtpCommand, signal
    },
      );
    }
  


export const getPostApiV1AuthOtpRequestMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthOtpRequest>>, TError,{data: RequestOtpCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthOtpRequest>>, TError,{data: RequestOtpCommand}, TContext> => {

const mutationKey = ['postApiV1AuthOtpRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1AuthOtpRequest>>, {data: RequestOtpCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1AuthOtpRequest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1AuthOtpRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1AuthOtpRequest>>>
    export type PostApiV1AuthOtpRequestMutationBody = RequestOtpCommand
    export type PostApiV1AuthOtpRequestMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1AuthOtpRequest = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthOtpRequest>>, TError,{data: RequestOtpCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1AuthOtpRequest>>,
        TError,
        {data: RequestOtpCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1AuthOtpRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1AuthOtpVerify = (
    verifyOtpCommand: VerifyOtpCommand,
 signal?: AbortSignal
) => {
      
      
      return request<AuthTokensDto>(
      {url: `/api/v1/auth/otp/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyOtpCommand, signal
    },
      );
    }
  


export const getPostApiV1AuthOtpVerifyMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthOtpVerify>>, TError,{data: VerifyOtpCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthOtpVerify>>, TError,{data: VerifyOtpCommand}, TContext> => {

const mutationKey = ['postApiV1AuthOtpVerify'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1AuthOtpVerify>>, {data: VerifyOtpCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1AuthOtpVerify(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1AuthOtpVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1AuthOtpVerify>>>
    export type PostApiV1AuthOtpVerifyMutationBody = VerifyOtpCommand
    export type PostApiV1AuthOtpVerifyMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1AuthOtpVerify = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthOtpVerify>>, TError,{data: VerifyOtpCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1AuthOtpVerify>>,
        TError,
        {data: VerifyOtpCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1AuthOtpVerifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1AuthRefresh = (
    refreshSessionCommand: RefreshSessionCommand,
 signal?: AbortSignal
) => {
      
      
      return request<AuthTokensDto>(
      {url: `/api/v1/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshSessionCommand, signal
    },
      );
    }
  


export const getPostApiV1AuthRefreshMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthRefresh>>, TError,{data: RefreshSessionCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthRefresh>>, TError,{data: RefreshSessionCommand}, TContext> => {

const mutationKey = ['postApiV1AuthRefresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1AuthRefresh>>, {data: RefreshSessionCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1AuthRefresh(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1AuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1AuthRefresh>>>
    export type PostApiV1AuthRefreshMutationBody = RefreshSessionCommand
    export type PostApiV1AuthRefreshMutationError = ProblemDetails

    export const usePostApiV1AuthRefresh = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthRefresh>>, TError,{data: RefreshSessionCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1AuthRefresh>>,
        TError,
        {data: RefreshSessionCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1AuthRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1AuthSignOut = (
    signOutCommand: SignOutCommand,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/auth/sign-out`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signOutCommand, signal
    },
      );
    }
  


export const getPostApiV1AuthSignOutMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthSignOut>>, TError,{data: SignOutCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthSignOut>>, TError,{data: SignOutCommand}, TContext> => {

const mutationKey = ['postApiV1AuthSignOut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1AuthSignOut>>, {data: SignOutCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1AuthSignOut(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1AuthSignOutMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1AuthSignOut>>>
    export type PostApiV1AuthSignOutMutationBody = SignOutCommand
    export type PostApiV1AuthSignOutMutationError = ProblemDetails

    export const usePostApiV1AuthSignOut = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1AuthSignOut>>, TError,{data: SignOutCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1AuthSignOut>>,
        TError,
        {data: SignOutCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1AuthSignOutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    